import { useEffect, useState } from "react";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useFetchExistingFiles = (leadID, oppRefID, refreshTrigger = 0) => {
  const [idFileCount, setIdFileCount] = useState(0);
  const [loaFileCount, setLoaFileCount] = useState(0);
  const [othersFileCount, setOthersFileCount] = useState(0);

  const [idFile, setIdFile] = useState([]);
  const [loaFile, setLoaFile] = useState([]);
  const [othersFile, setOthersFile] = useState([]);

  const [insuranceFiles, setInsuranceFiles] = useState([]);

  useEffect(() => {
    console.log("useFetchExistingFiles called with:", {
      leadID,
      oppRefID,
      refreshTrigger,
    });

    if (!leadID) {
      console.warn("useFetchExistingFiles: no leadID, skipping fetch");
      return;
    }

    const fetchFiles = async () => {
      // 1) ID / LOA / Misc
      try {
        const base = import.meta.env.VITE_BASE_URL;
        const url = `${base}/${API_ENDPOINTS.GET_FILES.EXISTING_FILES}/${leadID}`;
        console.log("Fetching base files:", url);

        const result = await apiRequest(url);
        const { files_count, files } = result;

        setIdFileCount(files_count?.id ?? 0);
        setLoaFileCount(files_count?.loa ?? 0);
        setOthersFileCount(files_count?.misc ?? 0);

        setIdFile(files?.id ?? []);
        setLoaFile(files?.loa ?? []);
        setOthersFile(files?.misc ?? []);
      } catch (error) {
        console.error("Error fetching existing files:", error);
        setIdFile([]);
        setLoaFile([]);
        setOthersFile([]);
        setIdFileCount(0);
        setLoaFileCount(0);
        setOthersFileCount(0);
      }

      // 2) Insurance PDFs
      if (!oppRefID) {
        console.warn(
          "useFetchExistingFiles: oppRefID is falsy, skipping insurance fetch"
        );
        setInsuranceFiles([]);
        return;
      }

      try {
        const base = import.meta.env.VITE_BASE_URL;
        const policyPath =
          API_ENDPOINTS?.INSURANCE?.GET_POLICY_PDFS || "get_policy_pdfs";

        const insuranceUrl = `${base}/${policyPath}?ref_id=${encodeURIComponent(
          oppRefID
        )}&refresh=${refreshTrigger}`;

        console.log("Fetching insurance files:", insuranceUrl);

        const insuranceRes = await apiRequest(insuranceUrl);

        if (Array.isArray(insuranceRes)) {
          setInsuranceFiles(insuranceRes);
        } else if (insuranceRes?.error) {
          console.warn(
            `No insurance PDFs found for ${oppRefID}:`,
            insuranceRes.error
          );
          setInsuranceFiles([]);
        } else {
          console.warn("Unexpected insurance response format:", insuranceRes);
          setInsuranceFiles([]);
        }
      } catch (err) {
        console.error(
          "Error fetching insurance files:",
          err?.response?.data || err?.message
        );
        setInsuranceFiles([]);
      }
    };

    fetchFiles();
  }, [leadID, oppRefID, refreshTrigger]);

  return {
    idFileCount,
    loaFileCount,
    othersFileCount,
    idFile,
    loaFile,
    othersFile,
    insuranceFiles,
  };
};